module.exports = __webpack_public_path__ + "img/category-brand.713b16de.png";